import { Link } from "react-router-dom";
import { events } from "@/mocks/events";
import StatusBadge from "@/components/base/StatusBadge";

export default function TimelineSpotlightSection() {
  const spotlight = events.find((e) => e.id === "streamer-preview-flop") ?? events[0];

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-foreground-950">
      <div className="w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-accent-400">
                <span className="w-6 h-px bg-accent-400" />
                时间线示范
              </span>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold leading-snug text-background-50">
                一条时间线
                <br />
                看懂整场反转
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-background-300">
                以正在持续发酵的事件为例：每个节点都会标注它的性质——是预热、反转、回应还是收尾，
                让你清楚看到剧情是在哪一步开始拐弯的。
              </p>

              <div className="mt-6 rounded-lg border border-foreground-800 bg-foreground-900 p-4">
                <div className="flex items-center gap-2">
                  <StatusBadge status={spotlight.status} />
                  <span className="text-xs text-background-400 whitespace-nowrap">
                    {spotlight.category}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-base font-bold leading-snug text-background-50">
                  {spotlight.title}
                </h3>
                <Link
                  to={`/event/${spotlight.id}`}
                  className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-primary-600 cursor-pointer"
                >
                  打开完整复盘
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </span>
                </Link>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative border-l border-foreground-700 pl-6 md:pl-8">
              {spotlight.timeline.map((node) => (
                <li key={node.title} className="relative pb-8 last:pb-0">
                  <span className="absolute -left-[31px] md:-left-[39px] top-1 w-3.5 h-3.5 rounded-full border-2 border-foreground-950 bg-primary-500" />
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-xs font-semibold text-accent-400">{node.date}</span>
                    {node.tag && (
                      <span className="rounded-full border border-foreground-700 bg-foreground-900 px-2 py-0.5 text-xs text-background-200">
                        {node.tag}
                      </span>
                    )}
                  </div>
                  <h3 className="mt-2 font-heading text-base font-bold text-background-50">
                    {node.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-background-300">{node.desc}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}